export default __webpack_public_path__ + "static/media/iconly-light-outline-search.374ea1a5.svg";